/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceDetailsListResponse {
    getFixupPrototypeFunction() { return ServiceResourceDetailsListResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceDetailsListResponse>): ServiceResourceDetailsListResponse {
        let obj = Object.assign(new ServiceResourceDetailsListResponse(), model);
        ServiceResourceDetailsListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceDetailsListResponse>): ServiceResourceDetailsListResponse {
        if (!model) return null;
        return ServiceResourceDetailsListResponse.newInstance(<ServiceResourceDetailsListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceDetailsListResponse) {
        if (!obj) return;

        models.ServiceResourceDetailsListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceDetailsListResponse): boolean {
        Object.setPrototypeOf(obj, ServiceResourceDetailsListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.ServiceResourceItem.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.ServiceResourceItem>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
